/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InstanceMembershipUserStatusEnum {
    ACTIVE = 'active',
    DEACTIVE = 'deactive',
    INVITATION_PENDING = 'invitation_pending',
    INVITATION_EXPIRED = 'invitation_expired',
}
